import { action, Action, Thunk, thunk } from 'easy-peasy';
import { editor } from '@/instance';

export interface IUserInfoParams {
    id: number;
    avatar: string;
    screen_name: string;
    is_vip?: boolean;
    vip_end_time?: number;
    email?: string;
}

export interface IUserInfoModel {
    userInfo: null | IUserInfoParams;
    setUserInfo: Action<IUserInfoModel, IUserInfoParams>;
    getUserInfo: Thunk<IUserInfoModel>;
    destroy: Action<IUserInfoModel>;
}

export const userInfoModel: IUserInfoModel = {
    /** 当前用户信息 */
    userInfo: null,
    /** 更新用户信息 */
    setUserInfo: action((state, payload) => {
        state.userInfo = payload;
        editor.setUid(payload.id);
    }),
    getUserInfo: thunk((actions, payload, state) => {
        return state.getState().userInfo;
    }),
    destroy: action((state) => {
        state.userInfo = null;
        editor.setUid(0);
    }),
};
